(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  document.querySelectorAll('[data-ae-pdp-ingredients-slider]').forEach((slider) => {
    if (slider.dataset.aeBound === 'true') return;
    slider.dataset.aeBound = 'true';

    const viewport = slider.querySelector('[data-ae-pdp-ingredients-viewport]');
    const track = slider.querySelector('[data-ae-pdp-ingredients-track]');
    const prev = slider.querySelector('[data-ae-pdp-ingredients-prev]');
    const next = slider.querySelector('[data-ae-pdp-ingredients-next]');
    const progress = slider.querySelector('[data-ae-pdp-ingredients-progress]');
    const slides = Array.from(track?.children || []);
    if (!viewport || !track || !slides.length) return;

    const pageStep = () => viewport.clientWidth * 0.85;

    const updateProgress = () => {
      if (!progress) return;
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      const pct = Math.max(0.12, Math.min(1, ratio || 0.12));
      progress.style.transform = `scaleX(${pct})`;
    };

    const updateArrows = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll - 1;
    };

    const refresh = () => { updateProgress(); updateArrows(); };

    // WebKit can leave a fast flick resting between snap points, which makes
    // the cards sit misaligned. When scrolling stops off-grid, glide to the
    // nearest card start so every swipe settles cleanly.
    let settleTimer;
    const settle = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const x = viewport.scrollLeft;
      if (maxScroll <= 0 || x <= 1 || x >= maxScroll - 1) return;
      const pad = parseFloat(getComputedStyle(viewport).scrollPaddingLeft) || 0;
      const vpLeft = viewport.getBoundingClientRect().left;
      let best = null;
      slides.forEach((s) => {
        const pos = s.getBoundingClientRect().left - vpLeft + x - pad;
        if (best === null || Math.abs(pos - x) < Math.abs(best - x)) best = pos;
      });
      if (best === null) return;
      best = Math.max(0, Math.min(best, maxScroll));
      if (Math.abs(best - x) > 2) viewport.scrollTo({ left: best, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => {
      viewport.scrollBy({ left: -pageStep(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: pageStep(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', () => {
      refresh();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 150);
    }, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  });
});
